const openFreezeModalReducers = (state = false, action) => {
  switch (action.type) {
    case "openOpenFreezeModal":
      return (state = true);
    case "closeOpenFreezeModal":
      return (state = false);
    default:
      return state;
  }
};
export default openFreezeModalReducers;
